<template>
  <div class="weChatPay">
    <div class="head-top">
      <div class="head-top-title">你好，欢迎使用微信付款！</div>
    </div>
    <div class="head">
      <div class="head-title">
        <span class="head-title-name">
          <svg
            t="1603428365742"
            class="icon"
            viewBox="0 0 1151 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2125"
            width="40"
            height="40"
          >
            <path
              d="M418.61 647.83a38.122 38.122 0 0 1-50.755-15.544l-2.494-5.533-104.74-231.612a19.957 19.957 0 0 1-1.824-8.155 19.19 19.19 0 0 1 5.629-13.657 19.19 19.19 0 0 1 13.56-5.693 18.837 18.837 0 0 1 11.482 3.87l123.642 88.43a56.608 56.608 0 0 0 51.17 5.885l581.43-260.652A613.796 613.796 0 0 0 575.29 0.485C257.678 0.58 0 217.098 0 483.89a455.837 455.837 0 0 0 198.831 365.104 38.762 38.762 0 0 1 15.991 31.598 46.95 46.95 0 0 1-2.015 12.633l-25.969 97.417a59.358 59.358 0 0 0-3.198 14.136 19.19 19.19 0 0 0 19.189 19.189 21.684 21.684 0 0 0 11.13-3.614l125.976-73.206a59.806 59.806 0 0 1 30.575-8.923 57.28 57.28 0 0 1 16.918 2.59 676.288 676.288 0 0 0 188.181 26.481c317.804 0 575.482-216.261 575.482-482.926a420.337 420.337 0 0 0-65.563-223.873L422.864 645.88l-4.19 2.462z"
              fill="#00B700"
              p-id="2126"
            ></path>
          </svg>
          <span>微信支付</span>
        </span>
      </div>
      <span class="title-border" />
      <span class="subTitle">我的收银台</span>
    </div>
    <div class="contion">
      <div class="contion-top">
        <div class="contion-top-left">
          <div>
            <span class="payee">收款方：</span>
            <span>{{ mallName }}</span>
          </div>
          <div>
            <span>订单编号：</span>
            <span>{{ orderCode }}</span>
          </div>
          <div>
            <span>商品名称：</span>
            <span>{{ goodsName }}</span>
          </div>
          <div>
            <span>订单类型：</span>
            <span>订单支付</span>
          </div>
        </div>
        <div class="contion-top-right">
          <span>应付金额：</span>
          <span class="amount">￥{{ orderPrice }}</span>
        </div>
      </div>
      <div class="contion-qrcode">
        <div class="content">
          <div class="text">扫一扫付款</div>
          <div class="amount">￥{{ orderPrice }}</div>
          <div id="qrcode" ref="qrcode"></div>
          <div class="explain">
            <img src="../../../assets/weChat/explain.png">
          </div>
        </div>
      </div>
    </div>
    <div class="foot" />
  </div>
</template>

<script>
//把链接转为二维码
import QRCode from "qrcodejs2";
import {
  getXBBasicInformation,
} from 'common/js/storage';
export default {
  data() {
    return {
      orderCode:'',
      orderPrice: 0,
      goodsName:'',
      mallName:''
    };
  },

  created() {
    this.orderCode = this.$route.query.orderCode
    this.orderPrice = this.$route.query.orderPrice
    this.goodsName = this.$route.query.goodsName
    this.mallName = getXBBasicInformation().mallName
    this.$nextTick(() => {
      this.qrcode();
    });
  },

  methods: {
    qrcode() {
      let url = JSON.parse(this.$route.query.weChatUrl);
      let qrcode = new QRCode("qrcode", {
        width: 220, // 设置宽度，单位像素
        height: 220, // 设置高度，单位像素
        text: url, // 设置二维码内容或跳转地址
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.weChatPay {
  width: 100%;
  height: 100vh;
  background: #f5f6f7;
  .head-top {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 26px;
    background: #81868b;
    .head-top-title {
      width: 148px;
      height: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      margin-right: 244px;
    }
  }
  .head {
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    background: #ffffff;
    border-bottom: 1px solid #ddd;
    .head-title {
      height: 40px;
      line-height: 40px;
      margin-left: 245px;
      .head-title-name {
        svg {
          width: 40px;
          height: 40px;
        }
        span {
          vertical-align: top;
          font-size: 24px;
          margin-left: 10px;
        }
      }
    }
    .title-border {
      width: 1px;
      height: 30px;
      background: #999999;
      margin: 0px 5px;
    }
    .subTitle {
      width: 80px;
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #606266;
      line-height: 20px;
      margin-top: 6px;
    }
  }
  .contion {
    margin: 0px 245px;
    .contion-top {
      margin: 24px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .contion-top-left {
        width: 214px;
        height: 72px;
        font-size: 12px;
        font-weight: 400;
        color: #606266;
        line-height: 20px;
        .payee {
          display: inline-block;
          width: 60px;
        }
      }
      .contion-top-right {
        width: 157px;
        height: 18px;
        font-size: 18px;
        font-weight: 400;
        color: #606266;
        line-height: 20px;
        .amount {
          color: #ff6600;
        }
      }
    }
    .contion-qrcode {
      display: flex;
      justify-content: center;
      height: 540px;
      border-top: 2px solid #afb5bc;
      background: #fff;
      .text {
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        line-height: 20px;
        margin-top: 62px;
        text-align: center;
      }
      .amount {
        height: 18px;
        font-size: 24px;
        font-weight: bold;
        color: #ff6600;
        line-height: 20px;
        margin-top: 14px;
        margin-bottom: 30px;
        text-align: center;
      }
      .explain {
        margin-top: 20px;
        img {
          width: 220px;
          height: 70px;
        }
      }
    }
  }
  .foot {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 90px;
    background: #fff;
  }
}
</style>
